import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { QaDashboardComponent } from './qa-dashboard/qa-dashboard.component';
import { QAReportDashboardComponent } from './qa-report-dashboard.component';
// import { QaReportGridComponent } from './qa-report-grid/qa-report-grid.component';
import { QaReportComponent } from './qa-report/qa-report.component';


const routes: Routes = [
  {
    path:'',
    component:QAReportDashboardComponent,
    children:[
      
      {path:'',component:QaDashboardComponent},
      {path:'qa-dashboard',component:QaDashboardComponent},
      // {path:'qa-report',component:QaReportComponent},
      {path:'rejection-on-yoy',component:QaReportComponent},
      {path:'rejection-on-qoq',component:QaReportComponent},
      {path:'rejection-by-field',component:QaReportComponent},
      {path:'rejection-by-eic',component:QaReportComponent},
      {path:'rejection-by-study-type',component:QaReportComponent},
      {path:'rejection-by-job',component:QaReportComponent},
      {path:'rejection-by-interviewer',component:QaReportComponent}
      
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class QAReportDashboardRoutingModule { }
